var BillyDataBelongsTo = require('./billy-data-belongs-to')

module.exports = BillyDataBelongsTo.extend({
    model: Billy.Contact
})
